import { type ReactNode } from "react";
import { useAbschnittsvorlagenSync } from "./abschnittsvorlagen";
import { useDashboardLayoutSync } from "./dashboard-layout";
import { useEinsatzmittelvorschlaegeSync } from "./einsatzmittelvorschlaege";
import { useFunkrufgruppenSync } from "./funkrufgruppen";
import { useHydrantenPrecacheSync, useHydrantenSync } from "./hydranten";
import { useInformationenSync } from "./informationen";
import {
  useKartenDetailObjektePrecacheSync,
  useKartenDetailObjekteSync,
} from "./kartendetailobjekte";
import { useKartenobjekteSync } from "./kartenobjekte";
import { useMapLayerSettingsSync } from "./map-layer-settings";
import { useMapLayersSync } from "./map-layers";
import { usePersonalSync } from "./personal";
import { usePzcCodesSync } from "./pzc-codes";
import { useResourcesSync } from "./resources";
import { useSperrungenPrecacheSync, useSperrungenSync } from "./sperrungen";
import { useStichworteSync } from "./stichworte";
import { useStrassenverzeichnisSync } from "./strassenverzeichnis";
import { useTacticalSignsSync } from "./tactical-signs";
import { useWeblinksSync } from "./weblinks";
import { useZielklinikObjekteSync } from "./zielklinik-objekte";

/**
 * Configures all data providers, displaying a loading screen until all data is ready.
 */
export function DbProvider({ children }: { children: ReactNode }) {
  useHydrantenSync();
  useHydrantenPrecacheSync();
  useKartenobjekteSync();
  useKartenDetailObjekteSync();
  useKartenDetailObjektePrecacheSync();
  useMapLayerSettingsSync();
  useMapLayersSync();
  useDashboardLayoutSync();
  useInformationenSync();
  useSperrungenSync();
  useSperrungenPrecacheSync();
  useResourcesSync();
  useWeblinksSync();
  useStrassenverzeichnisSync();
  useStichworteSync();
  useFunkrufgruppenSync();
  useAbschnittsvorlagenSync();
  usePersonalSync();
  useTacticalSignsSync();
  useEinsatzmittelvorschlaegeSync();
  usePzcCodesSync();
  useZielklinikObjekteSync();

  return <>{children}</>;
}
